<a *ngIf="documentId" href="javascript:void(0)" id="{{documentId}}" (click)="onLinkClick($event)">
    {{ "agGrid.agGridColumns.contextMenu.download" | translate }}
</a>